export const orbitAiStepCSS = {
  rootSec: {
    display: 'flex',
    maxWidth: 900,
    mx: 'auto',
    pb: 4,
    // pt: 3,
  },
  cardView: {
    flex: 2,
    borderRadius: '12px',
    p: { xs: 2, sm: 4 },
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
    border: '1px solid #EAECF0'
  },
  cardBox: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '3px',
    marginBottom: '8px'
  },
  cardNewText: {
    backgroundColor: '#E0FFFF',
    color: '#00B8D9',
    px: '8px',
    borderRadius: '20px',
    fontSize: '12px',
    border: '1px solid #00B8D9',
    marginLeft: '2px',
    letterSpacing: '0.4px'
  },
  letAiTextBox: {
    textAlign: 'center', marginBottom: '32px'
  },
  letAiText: {
    color: 'var(--color-text-secondary)',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px'
  },
  featureRow: {
    borderTop: '1px solid #EAECF0',
    width: '100%',
    display: 'flex',
    gap: 2,
    flexDirection: { xs: 'column', sm: 'row' }
  },
  featureBox: {
    width: '100%',
    paddingX: '16px',
    paddingBottom: '16px',
    paddingTop: '8px'
  },
  featureDesc: {
    fontFamily: 'Inter',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
    textAlign: 'left',
    color: '#120242'
  },
  inputBoxStart: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    minHeight: '28px',
    marginY: '2px',
    marginX: '2px',
    gap: '4px',
    minWidth: 0,
    overflow: 'hidden'
  },
  inputChip: {
    padding: '0px 0px 0px 4px',
    gap: '6px',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: 'var(--font-size-14)',
    color: 'var(--color-text-heading)',
    backgroundColor: 'var(--color-bg-muted-alt)',
    height: 28,
    whiteSpace: 'nowrap',
    textOverflow: 'inherit',
    borderRadius: '4px'
  },
  mainButton: {
    fontWeight: 600,
    textTransform: 'none',
    py: '12px',
    px: '18px',
    borderRadius: '6px',
    mt: 2,
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)'
  },
  textFieldInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      border: '1px solid var(--color-border)',
      '& fieldset': {
        border: 'none'
      },
      '&:hover fieldset': {
        border: 'none'
      },
      '&.Mui-focused fieldset': {
        border: 'none'
      },
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '8px',
      padding: '6px 2px 6px 4px'
    },
    '& .MuiInputBase-input': {
      flex: '1 0 150px',
      minWidth: 0,
      whiteSpace: 'nowrap'
    },
    '& input': {
      minWidth: '150px',
      flexGrow: 1,
      flexShrink: 1,
      whiteSpace: 'nowrap'
    }
  }
}